export const ROLES = {
  Admin: { id: 1, slug: 'admin' },
  AnalyticsManager: { id: 2, slug: 'analytics-manager' },
  AnalyticsStore: { id: 3, slug: 'analytics-store' },
  AnalyticsBrand: { id: 4, slug: 'analytics-brand' },
  Catalog: { id: 5, slug: 'curate' },
  Benefits: { id: 6, slug: 'benefits' },
  BenefitsAccessManagement: { id: 7, slug: 'benefits-access-management' }
};
